import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import useFetchData from "../../../../hooks/useFetchData";
import { Link } from "react-router-dom";
import { Previous } from "../../../../components/Icons/Icons";
import FormAdd from "../AddRole/FormAdd";
import ListRoleSelect from "../ListRole/ListRoleSelect";
import { role } from "../../../../services/api/RoleApi";
import styles from "./EditRole.module.css";
import { Toast } from "../../../../components";

const cx = classNames.bind(styles);
const AddRole = () => {
  const navigate = useNavigate();
  const prams = useParams();
  const [newRole, setNewRole] = useState({
    subject_name: "",
    note: "",
  });
  const [listRole, setListRole] = useState([]);
  const handleAddRole = () => {
    async function addRole() {
      try {
        if (newRole.subject_name && newRole.subject_name !== "") {
          const data = {
            ...newRole,
            company_code:prams.id,
            list_permissions: {
              data: listRole,
            },
          };
          const res = await role.newRole(JSON.stringify(data));
          if (res) {
            Toast.open("Thêm quyền thành công","success");
            navigate("/admin/role");
          } else {
            Toast.open("Thêm quyền không thành công","danger");
          }
        }
        else{
          Toast.open("Vui lòng nhập tên quyền mới","danger")
        }
      } catch (e) {
        Toast.open("Thêm quyền không thành công","danger");
      }
    }
    addRole();
  };
  const listPermission = useFetchData("/permission/get-list-permission/", {
    usertype_code: prams.id,
  });

  useEffect(() => {
    async function listRoleSelect() {
      const data = listPermission?.data?.map((item) => {
        return {
          PERMISSION_TYPE_CODE: item.PERMISSION_TYPE_CODE,
          USER_FUNCTION_CODE: item.USER_FUNCTION_CODE,
          NOTE: item.NOTE,
        };
      });
      setListRole(data);
   
    }
    listRoleSelect();
  }, [listPermission.data]);
  return (
    <div className={cx("container")}>
      <div className={cx("header")}>
        <Link style={{ textDecoration: "none" }} to="/admin/role">
          <span className={cx("icon")}>
            <Previous />
          </span>
        </Link>
        <h1 className={cx("title")}>Chỉnh sửa quyền</h1>
      </div>
      <div className={cx("content")}>
        <div className={cx("item_add")}>
          <FormAdd
            nameRole={listPermission?.data[0]?.TYPE_NAME}
            newRole={newRole}
            setNewRole={setNewRole}
          />
        </div>
        <div className={cx("item-user")}>
          <ListRoleSelect
            role={listRole}
            setRole={setListRole}
            title={"Danh sách chức năng"}
            type="Thêm"
            userType={prams.id}
            listPermission={listPermission}
          />
        </div>
      </div>
      <div className={cx("footer")}>
        <button onClick={handleAddRole} className={cx("btn-add")}>
          Xác nhận
        </button>
        <button className={cx("btn-cancel")}>Hủy bỏ</button>
      </div>
    </div>
  );
};

export default AddRole;
